import type { OrganizationRequest, OrganizationResponseItem } from '../types';
import { OrganizationForm } from './forms/organization-form';

interface OrganizationInformationProps {
  information?: OrganizationResponseItem;
  updateOrganization(requestBody: OrganizationRequest): void;
}

export function OrganizationInformation({
  information,
  updateOrganization,
}: Readonly<OrganizationInformationProps>) {
  return (
    <OrganizationForm
      isUpdating
      initialValues={information}
      onFinish={updateOrganization}
    />
  );
}
